<template>
  <div>
    <div class="MClass">
      <!-- Loading Indicator -->
      <div v-if="loading" class="text-center mt-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <!-- Error Message -->
      <div v-if="error" class="alert alert-danger mt-4">
        {{ error }}
      </div>

      <!-- User Profile -->
      <div v-if="userProfile">
        <!-- Main Content -->
        <div class="main"></div>

        <!-- Profile Image -->
        <div class="circle">
          <img :src="userProfile.profile_photo_url" alt="Profile Photo" />
        </div>

        <!-- Profile Card -->
        <div class="container d-flex justify-content-center">
          <div class="card cardArea">
            <div class="card-body">
              <h5 class="card-title d-flex justify-content-between align-items-center">
                Profile Information
                <button
                  class="btn btn-outline-primary btn-sm"
                  data-bs-toggle="modal"
                  data-bs-target="#editProfileModal"
                >
                  <i class="bi bi-pencil-fill"></i>
                </button>
              </h5>
              <!-- <p class="mt-3">My ID: {{ userProfile.id }}</p> -->
              <p>First Name: {{ userProfile.first_name }}</p>
              <p>Last Name: {{ userProfile.last_name }}</p>
              <p>Email: {{ userProfile.email }}</p>

<!-- Institutes Table -->
<div v-if="userProfile.teach_institute_details && userProfile.teach_institute_details.length > 0">
  <h5>Institutes</h5>
  <table class="table">
    <thead>
      <tr>
        <th>Institute Name</th>
        <th>Location</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="instituteDetail in userProfile.teach_institute_details" :key="instituteDetail.id">
        <td>{{ instituteDetail.institute.institute_name }}</td>
        <td>{{ instituteDetail.institute.location ? instituteDetail.institute.location.name : 'N/A' }}</td>
      </tr>
    </tbody>
  </table>
</div>
<p v-else class="text-muted">No institutes available.</p>

            </div>
          </div>
        </div>
      </div>

<!-- Edit Profile Modal -->
<div class="modal fade" id="editProfileModal" tabindex="-1" aria-labelledby="editProfileModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Edit Profile</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <!-- Success Message -->
        <div v-if="successMessage" class="alert alert-success">
          {{ successMessage }}
        </div>

        <!-- Error Message -->
        <div v-if="errorMessage" class="alert alert-danger">
          {{ errorMessage }}
        </div>

        <div class="mb-3">
          <label for="firstName" class="form-label">First Name</label>
          <input
            type="text"
            class="form-control"
            id="firstName"
            v-model="editedProfile.first_name"
          />
        </div>
        <div class="mb-3">
          <label for="lastName" class="form-label">Last Name</label>
          <input
            type="text"
            class="form-control"
            id="lastName"
            v-model="editedProfile.last_name"
          />
        </div>
        <div class="mb-3">
          <label for="profilePhoto" class="form-label">Profile Photo</label>
          <input
            type="file"
            class="form-control"
            id="profilePhoto"
            @change="handleProfilePhotoChange"
          />
          <img
            v-if="editedProfile.profile_photo_preview"
            :src="editedProfile.profile_photo_preview"
            alt="Profile Preview"
            class="mt-2 img-thumbnail"
            style="width: 150px; height: 150px;"
          />
          <img
            v-else
            :src="(userProfile?.profile_photo_url)"
            alt="Current Profile Photo"
            class="mt-2 img-thumbnail"
            style="width: 150px; height: 150px;"
          />
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" @click="saveProfileChanges">Save changes</button>
      </div>
    </div>
  </div>
</div>



    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      loading: true,
      error: null,
      editedProfile: {
        first_name: '',
        last_name: '',
        teacher_profile_photo: null, // Will be null if no photo is selected
        profile_photo_preview: null, // For preview image
      },
      userProfile: {
        profile_photo_url: '' // URL of the current profile photo
      },
      successMessage: '',
      errorMessage: '',
    };
  },
  created() {
    this.fetchUserProfile();
  },
  methods: {
    async fetchUserProfile() {
      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("id");

      if (!token || !userId) {
        this.error = "User not authenticated";
        this.loading = false;
        return;
      }

      try {
        const response = await axios.get(`/getTeachersProfile/${userId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        this.userProfile = response.data;

        // Check and log teacher details if available
        if (response.data.teacher) {
          console.log("Teacher Details:", response.data.teacher);
        }

        this.editedProfile = { ...response.data }; // Initialize edited profile data
      } catch (err) {
        this.error = "Error fetching user data";
      } finally {
        this.loading = false;
      }
    },
    handleProfilePhotoChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.editedProfile.teacher_profile_photo = file;
        this.editedProfile.profile_photo_preview = URL.createObjectURL(file);
      }
    },
    async saveProfileChanges() {
  try {
    const formData = new FormData();
    formData.append('first_name', this.editedProfile.first_name);
    formData.append('last_name', this.editedProfile.last_name);

    if (this.editedProfile.teacher_profile_photo === null) {
      formData.append('teacher_profile_photo', null); // Explicitly append null
    } else if (this.editedProfile.teacher_profile_photo) {
      formData.append('teacher_profile_photo', this.editedProfile.teacher_profile_photo);
    }

    // Send the request to the backend
    const response = await axios.post(`/updateTeacherProfile/${this.userId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${this.token}`,
      },
    });

    // Handle the success response
    if (response.data.message) {
      this.successMessage = response.data.message;
      this.errorMessage = ''; // Reset error message

      // Update userProfile with the edited values directly
      this.userProfile.first_name = this.editedProfile.first_name;
      this.userProfile.last_name = this.editedProfile.last_name;
      this.userProfile.profile_photo_url = this.editedProfile.profile_photo_preview || this.userProfile.profile_photo_url;

      // Optionally, if you want to refetch the profile data from the server:
      // this.fetchUserProfile();
    }

  } catch (error) {
    // Handle error response
    if (error.response && error.response.data.error) {
      this.errorMessage = error.response.data.error;
      this.successMessage = ''; // Reset success message
    }
  }
},
  },
  mounted() {
    // Initialize user data (you might retrieve this from local storage or API)
    this.userId = localStorage.getItem('id');
    this.token = localStorage.getItem('token');
  },
};
</script>

<style lang="scss" scoped>
.MClass{
  width: 100%;
  padding-bottom: 5dvh;
  height: 100%;
}
.main {
  width: 100%;
  height: 200px;
  border-radius: 5px;
  background-image: url("@/assets/ProfileIMG/imgD.jpg");
  background-size: cover;
  background-position: center;
}

.circle {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  margin-top: -100px;
  margin-left: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.circle img {
  width: 100%;
  height: 100%;
  border-radius: 50%;      /* makes it a circle */
  border: 4px solid #ffffff; /* add border (change color & size as needed) */
  object-fit: cover;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
}

.cardArea {
  width: 100%;
  margin-top: 5vh;
}

.card-body {
  text-align: left;
}
</style>
